module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.status),
      expression: "!status"
    }],
    staticClass: "loading"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "loading-text"
  }, [_vm._v("正在加载...")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "la-square-spin"
  }, [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d80e7146!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading.vue
// module id = 29
// module chunks = 7 8 9 10